import React from 'react';
import Text from '../../../../Components/Base/Text/Text';

//@ts-ignore
import styles from './EHRNoItemsFound.module.scss';

const EHRNoItemsFound: React.FC = () => {

  return (
    <div className={styles.wrapper}>
      <Text tx={'nczi.noItemsFound'} firstUpper />
    </div>
  );
};

export default EHRNoItemsFound;